import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "table-sortable-header__cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!

  return (_openBlock(), _createElementBlock("thead", {
    class: _normalizeClass(['table-sortable-header', _ctx.headClass])
  }, [
    _createElementVNode("tr", null, [
      _renderSlot(_ctx.$slots, "leading", {}, undefined, true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
        return (_openBlock(), _createElementBlock("th", {
          key: column.field,
          class: _normalizeClass(['table-sortable-header__th', { 'table-sortable-header__th_sortable': column.sortable }]),
          onClick: ($event: any) => (_ctx.onColumnClick(column))
        }, [
          _createElementVNode("span", _hoisted_2, [
            _createTextVNode(_toDisplayString(column.title) + " ", 1),
            (column.sortable)
              ? (_openBlock(), _createBlock(_component_ButtonComponent, {
                  key: 0,
                  buttonType: "button",
                  class: _normalizeClass(["table-sortable-header__sort", _ctx.getSortClass(column)])
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_IconComponent, {
                      class: "table-sortable-header__sort-icon table-sortable-header__sort-icon_up",
                      name: "chevronDownSort"
                    }),
                    _createVNode(_component_IconComponent, {
                      class: "table-sortable-header__sort-icon table-sortable-header__sort-icon_down",
                      name: "chevronDownSort"
                    })
                  ]),
                  _: 1
                }, 8, ["class"]))
              : _createCommentVNode("", true)
          ])
        ], 10, _hoisted_1))
      }), 128))
    ])
  ], 2))
}